export default __webpack_public_path__ + "static/media/forgenft.53bcc8d5.png";